export default {
  appbar: {
    signupButton: "تسجيل",
    loginButton: "تسجيل الدخول"
  },
  loginPage: {
    title: "تسجيل الدخول إلى Excoino",
    emailOrMobile: {
      label: "رقم الهاتف المحمول أو البريد الإلكتروني",
      validation: "إدخال رقم الهاتف المحمول أو البريد الإلكتروني مطلوب"
    },
    password: {
      label: "كلمة المرور",
      validation: {
        notEmpty: "إدخال كلمة المرور مطلوب",
        notPersian: "أدخل كلمة المرور بأحرف لاتينية"
      }
    },
    forgetPasswordLink: "نسيت كلمة المرور؟",
    loginButton: "تسجيل الدخول",
    signUpBefore: "لم تسجل بعد؟",
    signUpBeforeLink: "تسجيل"
  },
  passwordRecoveryPage: {
    title: "استعادة كلمة المرور",
    emailOrMobile: {
      label: "رقم الهاتف المحمول أو البريد الإلكتروني",
      validation: "إدخال رقم الهاتف المحمول أو البريد الإلكتروني مطلوب"
    },
    passwordRecoveryButton: "متابعة"
  },
  passwordRecoveryOTPPage: {
    title: "استعادة كلمة المرور",
    subtitle: {
      part1: "لاستعادة كلمة المرور، أدخل الرمز المرسل إلى ",
      part2: ""
    },
    otpCode: {
      placeholder: "رمز التحقق",
      validation: "إدخال رمز التحقق مطلوب"
    },
    timeTitle: " إعادة إرسال الرمز في {count} ثانية",
    passwordRecoveryOTPButton: "متابعة",
    passwordRecoveryOTPResendButton: "إعادة إرسال رمز التحقق"
  },
  passwordResetPage: {
    title: "تغيير كلمة المرور",
    subtitle: "أدخل كلمة المرور الجديدة",
    password: {
      label: "كلمة المرور",
      validation: {
        notEmpty: "إدخال كلمة المرور مطلوب",
        notPersian: "أدخل كلمة المرور بأحرف لاتينية"
      }
    },
    passwordConfirm: {
      label: "تأكيد كلمة المرور",
      validation: "إدخال تأكيد كلمة المرور مطلوب"
    },
    passwordResetButton: "تأكيد",
    validationTitle: "متطلبات كلمة المرور:"
  },
  googleAuthPage: {
    title: "مصادقة Google",
    subtitle: "أدخل رمز Google Authenticator المكون من 6 أرقام لتسجيل الدخول",
    otpCode: {
      placeholder: "رمز Google Authenticator",
      validation: "إدخال رمز التحقق مطلوب"
    },
    googleAuthButton: "تأكيد وتسجيل الدخول"
  },
  emailAuthPage: {
    title: "مصادقة البريد الإلكتروني",
    subtitle: {
      part1: "لتسجيل الدخول، يرجى إدخال الرمز المرسل إلى (",
      part2: ")."
    },
    otpCode: {
      placeholder: "رمز التحقق",
      validation: "إدخال رمز التحقق مطلوب"
    },
    emailAuthButton: "تأكيد وتسجيل الدخول"
  },
  otpAuthPage: {
    title: "مصادقة الرسائل القصيرة",
    subtitle: {
      part1: "لتسجيل الدخول، يرجى إدخال الرمز المرسل إلى (",
      part2: ")."
    },
    otpCode: {
      placeholder: "رمز التحقق",
      validation: "إدخال رمز التحقق مطلوب"
    },
    timeTitle: " إعادة إرسال الرمز في {count} ثانية",
    otpAuthButton: "تأكيد وتسجيل الدخول",
    otpAuthResetButton: "إعادة إرسال رمز التحقق"
  },
  registerPage: {
    title: "تسجيل في Excoino",
    emailOrMobile: {
      label: "رقم الهاتف المحمول أو البريد الإلكتروني",
      validation: "إدخال رقم الهاتف المحمول أو البريد الإلكتروني مطلوب"
    },
    password: {
      label: "كلمة المرور",
      validation: {
        notEmpty: "إدخال كلمة المرور مطلوب",
        notPersian: "أدخل كلمة المرور بأحرف لاتينية"
      }
    },
    passwordConfirm: {
      label: "تأكيد كلمة المرور",
      validation: "إدخال تأكيد كلمة المرور مطلوب"
    },
    referralCode: {
      title: "رمز الإحالة (اختياري)",
      label: "رمز الإحالة"
    },
    policyLink: "أوافق على الشروط والأحكام",
    policyTitle: "خاصة بـ Excoino.",
    signUpButton: "متابعة",
    signInBefore: "مسجل بالفعل؟",
    signInBeforeLink: "تسجيل الدخول",
    validationTitle: "متطلبات كلمة المرور:"
  },
  registerVerificationPage: {
    title: "تسجيل في Excoino",
    subtitle: {
      part1: "لتسجيل في Excoino، يرجى إدخال الرمز المرسل إلى",
      part2: "."
    },
    verificationCode: {
      placeholder: "رمز التحقق",
      validation: "إدخال رمز التحقق مطلوب"
    },
    timeTitle: " إعادة إرسال الرمز في {count} ثانية",
    verificationButton: "تسجيل الدخول",
    verificationResetButton: "إعادة إرسال رمز التحقق"
  },
  registerConfirmedPage: {
    title: "تم إنشاء حساب Excoino الخاص بك.",
    subtitle: "سيتم تحويلك تلقائيًا إلى صفحة تسجيل الدخول في {count} ثانية.",
    goToLoginButton: "تسجيل الدخول وإكمال التحقق",
    completeAuth: "لاستخدام جميع ميزات Excoino، أكمل التحقق الخاص بك."
  },
  emailVerifiedPage: {
    title: "تم التحقق من بريدك الإلكتروني بالفعل.",
    subtitle: {
      part1: "إذا كان لديك أي أسئلة، اتصل بـ",
      part2: "الدعم.",
      linkTitle: "الدعم"
    },
    emailVerifiedButton: "تسجيل الدخول إلى الحساب"
  },
  emailSuccessPage: {
    title: "تم التحقق من بريدك الإلكتروني",
    subtitle: "يمكنك الآن تسجيل الدخول إلى حسابك.",
    emailSuccessButton: "تسجيل الدخول إلى الحساب"
  },
  emailInvalidPage: {
    title: "رابط التفعيل غير صالح",
    subtitle: {
      part1: "إذا كان لديك أي أسئلة، اتصل بـ",
      part2: "الدعم.",
      linkTitle: "الدعم"
    },
    emailInvalidButton: "تسجيل الدخول إلى الحساب"
  }
};
